import React from 'react';
import { TooltipData, useChartTooltip } from './ChartTooltip';

interface HorizBarProps {
  label: string;
  count: number;
  pct: number;        // 0-100
  color: string;
  labelWidth?: number;
  countWidth?: number;
  barHeight?: number;
  showPct?: boolean;
  labelColor?: string;
  tooltip?: TooltipData;
}

const HorizBar: React.FC<HorizBarProps> = ({
  label, count, pct, color,
  labelWidth = 100,
  countWidth = 26,
  barHeight = 9,
  showPct = false,
  labelColor,
  tooltip,
}) => {
  const { show, move, hide, tooltipEl } = useChartTooltip();

  const handlers = tooltip
    ? {
        onMouseEnter: (e: React.MouseEvent) => show(tooltip, e),
        onMouseMove: move,
        onMouseLeave: hide,
      }
    : {};

  return (
    <>
      {tooltipEl}
      <div
        style={{ display: 'flex', alignItems: 'center', gap: 9, cursor: tooltip ? 'crosshair' : undefined }}
        {...handlers}
      >
        <span
          style={{
            flex: `0 0 ${labelWidth}px`,
            fontFamily: 'var(--font-mono)',
            fontSize: 'var(--an-text-sm)',
            color: labelColor ?? 'var(--foreground)',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </span>
        <div
          style={{
            flex: 1,
            height: barHeight,
            borderRadius: 9999,
            background: 'var(--an-surface-muted)',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              width: `${Math.max(pct, 1)}%`,
              height: barHeight,
              borderRadius: 9999,
              background: color,
              transition: 'width 0.4s ease',
            }}
          />
        </div>
        {showPct ? (
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--an-text-secondary)', width: countWidth, textAlign: 'right' }}>
            {pct}%
          </span>
        ) : (
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--an-text-secondary)', width: countWidth, textAlign: 'right' }}>
            {count}
          </span>
        )}
      </div>
    </>
  );
};

export default HorizBar;
